var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d21ed0e4eb5e6dab579c54c0f8b731d5d56f292c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["payex-web@flywire"]={id:"d21ed0e4eb5e6dab579c54c0f8b731d5d56f292c"};
      